var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "dialog", class: { active: _vm.showDialog } },
    [
      _c(
        "div",
        {
          staticClass:
            "dialog--content dialog--extended-width u-extra-medium-padding--bottom",
        },
        [
          _c("h4", { staticClass: "u-extra-small-margin--bottom" }, [
            _vm._v(_vm._s(_vm.$t("search.project.title"))),
          ]),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s(_vm.$t("search.project.intro")))]),
          _vm._v(" "),
          _c("div", { staticClass: "grid-x grid-margin-x" }, [
            _c("div", { staticClass: "cell small-auto medium-8" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.project_number,
                    expression: "project_number",
                  },
                ],
                attrs: {
                  type: "text",
                  placeholder: _vm.$t("search.project_number"),
                },
                domProps: { value: _vm.project_number },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.project_number = $event.target.value
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "cell small-auto medium-4" }, [
              _c(
                "button",
                {
                  staticClass: "button",
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.projectSearch.apply(null, arguments)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("search")))]
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "cell auto" },
              [
                _c("v-table", {
                  staticClass: "c-tourplan-table u-extra-small-margin--top",
                  attrs: {
                    isLoading: _vm.projectsTableLoading,
                    columns: _vm.projectsTableColumns,
                    items: _vm.projectsTableItems,
                    showHeaderRow: true,
                    showShowAll: false,
                    useDetailRow: false,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "project_number",
                        fn: function ({ row }) {
                          return [
                            row.project_number
                              ? _c("span", [
                                  _c("strong", [
                                    _vm._v(_vm._s(row.project_number)),
                                  ]),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.projectHasRoute(row)
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "callout alert u-text-center",
                                  },
                                  _vm._l(
                                    row.tour_routes,
                                    function (route, index) {
                                      return _c(
                                        "div",
                                        { key: index },
                                        [
                                          _c(
                                            "router-link",
                                            {
                                              staticClass: "u-no-margin",
                                              attrs: {
                                                to: {
                                                  name: "update-tour",
                                                  params: {
                                                    tour: route.tour_id,
                                                  },
                                                },
                                                title: _vm.$t("update"),
                                              },
                                            },
                                            [_vm._v(_vm._s(route.tour_number))]
                                          ),
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                  0
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                      {
                        key: "company_name",
                        fn: function ({ row }) {
                          return [
                            row.customer
                              ? _c(
                                  "p",
                                  {
                                    staticClass:
                                      "u-no-margin c-tourplan-table__company-name",
                                  },
                                  [_vm._v(_vm._s(row.customer.company_name))]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            row.account
                              ? _c("p", { staticClass: "u-no-margin" }, [
                                  _vm._v(
                                    _vm._s(row.account.profile.firstname) +
                                      " " +
                                      _vm._s(row.account.profile.lastname)
                                  ),
                                ])
                              : _vm._e(),
                          ]
                        },
                      },
                      {
                        key: "address",
                        fn: function ({ row }) {
                          return [
                            _c("p", { staticClass: "u-no-margin" }, [
                              _c("strong", [
                                _vm._v(
                                  _vm._s(row.address.zipcode) +
                                    " " +
                                    _vm._s(row.address.city)
                                ),
                              ]),
                              _vm._v(" "),
                              _c("br"),
                              _vm._v(
                                "\n              " +
                                  _vm._s(row.address.street) +
                                  " " +
                                  _vm._s(row.address.housenumber) +
                                  "\n            "
                              ),
                            ]),
                          ]
                        },
                      },
                      {
                        key: "layers",
                        fn: function ({ row }) {
                          return row.layers
                            ? _vm._l(row.layers, function (layer, index) {
                                return _c(
                                  "p",
                                  { key: index, staticClass: "u-no-margin" },
                                  [
                                    _c("strong", [
                                      _vm._v(_vm._s(layer.subtype)),
                                    ]),
                                  ]
                                )
                              })
                            : undefined
                        },
                      },
                      {
                        key: "openqm",
                        fn: function ({ row }) {
                          return row.stats
                            ? [
                                _c("p", [
                                  _vm._v(
                                    _vm._s(row.stats.qm.open) +
                                      " / " +
                                      _vm._s(row.stats.qm.total)
                                  ),
                                ]),
                              ]
                            : undefined
                        },
                      },
                      {
                        key: "action",
                        fn: function ({ row }) {
                          return [
                            !row.alreadyInSearchResult
                              ? _c("div", [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "button secondary",
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.selectProject(row)
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("tours.addproject")))]
                                  ),
                                ])
                              : _c("p", { staticClass: "u-error" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("tours.error.hasmatch"))
                                  ),
                                ]),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "close-button",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.onCloseDialog.apply(null, arguments)
                },
              },
            },
            [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }